import dayjs, { Dayjs } from 'dayjs';
import { Region } from '../types/orderTypes';
import { queryStringFromObject } from 'utils/urlUtil';
import Fetch from '../utils/fetch';
import { settings } from '../settings';
import { Co2ReportInterface } from '../pages/reports/Co2Report/Co2Report.types';

const dateFormat = 'YYYY-MM-DD';

type OperationalRegion =
  | 'OSLO'
  | 'TRONDHEIM'
  | 'BERGEN'
  | 'STAVANGER'
  | 'VESTFOLD'
  | 'GRENLAND'
  | 'OSTFOLD'
  | 'KRISTIANSAND';

export interface InvoiceLineWithKey {
  courierId: number;
  description: string;
  date: string;
  count: number;
  price: number;
  sendToDipps: boolean;
  operationalRegion: OperationalRegion;
  vat: number;
  lineItemKey: string;
  invoicingRegion: string;
  vehicleCategory: string;
}

export interface DeliveryDetails {
  id: string;
  courierName?: string;
  deliveryDate: string;
  rating: number;
  feedback?: string;
  feedbackFlags: string[];
  orderIds: string[];
  region: Region;
  recipientAddress: string;
  recipientName: string;
  senderName: Array<string>;
}

export async function fetchCo2DataAsync(
  startDate: Date,
  endDate: Date
): Promise<Co2ReportInterface[]> {
  const start = dayjs(startDate).format(dateFormat);
  const end = dayjs(endDate).format(dateFormat);
  const url = `${settings.newApiUrl}/reports/bundle/co2?start=${start}&end=${end}`;
  const response = await Fetch.get({ url });
  return response.json();
}

export async function fetchInvoice(
  start: Dayjs,
  end: Dayjs,
  courierId?: string
): Promise<InvoiceLineWithKey[]> {
  try {
    const courierIdPath = courierId == null ? '' : `/${courierId}`;
    const queryParams = queryStringFromObject({
      startDate: start.format(dateFormat),
      endDate: end.format(dateFormat),
    });
    const url = `${settings.invoiceApiUrl}/report${courierIdPath}${queryParams}`;
    const response = await Fetch.get({ url });
    return response.ok ? response.json() : [];
  } catch (e) {
    console.error('Error fetching invoice', e);
    return [];
  }
}

export async function fetchAllDeliveries(
  startDate: Dayjs,
  endDate: Dayjs,
  region: Region = undefined
): Promise<DeliveryDetails[]> {
  try {
    const queryParams = {
      start: dayjs(startDate).format(dateFormat),
      end: dayjs(endDate).format(dateFormat),
      region,
    };
    const queryString = queryStringFromObject(queryParams);
    const url = `${settings.newApiUrl}/reports/deliveries/list${queryString}`;
    const response = await Fetch.get({ url });
    return response.ok ? await response.json() : null;
  } catch (e) {
    console.log(`Error fetching deliveries`, e);
    return null;
  }
}
